import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  openPictureModal(event) {
    const path = atob(event.params.encodedPath)

    if (this.signal) {
      this.abortController.abort()
    }

    this.abortController = new AbortController()
    this.signal = this.abortController.signal

    fetch(path, {
      method: "GET",
      signal: this.signal,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(() => {});
  }
}
